const STORAGE_KEY = "doubtbuddy-theme";

export function getStoredTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function getSystemTheme() {
  if (typeof window === "undefined") {
    return "light";
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function getEffectiveTheme() {
  const stored = getStoredTheme();
  if (stored === "light" || stored === "dark") {
    return stored;
  }

  return getSystemTheme();
}

export function applyTheme(theme) {
  const root = document.documentElement;

  if (theme === "light" || theme === "dark") {
    root.setAttribute("data-theme", theme);
    root.style.colorScheme = theme;
    return;
  }

  root.removeAttribute("data-theme");
  root.style.colorScheme = getSystemTheme();
}

export function initTheme() {
  applyTheme(getStoredTheme());
}

export function setTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Ignore storage failures (private mode, etc.)
  }

  applyTheme(theme);
  return theme;
}

export function toggleTheme(currentTheme) {
  return setTheme(currentTheme === "dark" ? "light" : "dark");
}
